import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Upward.svg",
  "use": "Upward.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Upward.svg\"><path d=\"M25.0221,52V32.0112H17.0179a2.0033,2.0033,0,0,1-1.536-3.2853L30.4805,10.6992a1.9978,1.9978,0,0,1,3.0724,0L48.5511,28.7259a2.0033,2.0033,0,0,1-1.5362,3.2853H39.0092V52a1.9991,1.9991,0,0,1-1.9982,2H27.02A1.9991,1.9991,0,0,1,25.0221,52Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol